import script from "./CategoryTreeNode.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryTreeNode.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryTreeNode.vue?vue&type=style&index=0&id=67cc12b4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67cc12b4"]])

export default __exports__